import styled from 'styled-components';
import GreenTickSvg from '../../assets/mytrips/green-tick.svg';

const GreenTickIcon = styled(GreenTickSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.7rem'};
  height: ${props => props.height || '1.6rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default GreenTickIcon;
